import embedRouterConfig from './router'

const embedConfig = {
	navigation: [],
	router: embedRouterConfig
}

export default embedConfig
